module.exports = __webpack_public_path__ + "static/media/9.8dc63fc8.jpeg";